/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useViewport from 'hooks/useViewport';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faSpotify,
  faInstagram,
  faFacebook,
  faTiktok,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { NavigationItemType } from 'types';
import ReactGA from 'react-ga4';
import { ArtistContext } from '../../context/ArtistContext';
import './nav.scss';

export default function Nav() {
  const { isMobile } = useViewport();
  const [visibleBottom, setVisibleBottom] = useState<boolean>(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  useEffect(() => {
    window.addEventListener('scroll', stickyCallBak);

    return () => {
      window.removeEventListener('scroll', stickyCallBak);
    };
  });

  const stickyCallBak = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 350 ? setIsScrolled(true) : setIsScrolled(false);
  };

  const artist = useContext(ArtistContext);
  if (!artist) return <div />;

  const {
    title,
    logo,
    isSpanish,
    siteCssBodyClass,
    facebookLink,
    tikTokLink,
    instagramLink,
    spotifyLink,
    twitterLink,
    youtubeLink,
    bookingPhoneOne,
    bookingEmailOne,
    bookingNameOne,
    navigation,
    siteLibraryJson,
    logoSecondary,
  } = artist;

  if (window.location.pathname === '/') {
    document.body.classList.add('home');
    document.body.classList.remove('sub-page');
  } else {
    document.body.classList.remove('home');
    document.body.classList.add('sub-page');
  }

  document.body.classList.add(siteCssBodyClass && siteCssBodyClass);
  if (siteLibraryJson?.siteID) {
    document.body.classList.add(siteLibraryJson?.siteID);
  }

  // const { logoSecondary } = props;

  return (
    <>
      {!!navigation?.announcementLink?.link && (
        <div className="announcement-bar w-full text-center py-2">
          <a
            href={navigation?.announcementLink?.link}
            onClick={() =>
              ReactGA.event({
                category: 'Link',
                action: `Visit ${navigation?.announcementLink?.link}`,
                label: navigation?.announcementLink?.link,
              })
            }
            target={!navigation?.sameTab === true ? '' : '_blank'}
            className={`text-link mx-auto text-center inline-block max-w-max uppercase text-xs opacity-50  ${navigation?.announcementLink?.cssClass}`}
            rel="noreferrer">
            {navigation?.announcementLink?.label}
          </a>
        </div>
      )}
      {isMobile ? (
        <>
          <Sidebar
            visible={visibleBottom}
            position="bottom"
            style={{ minHeight: '90vh' }}
            onHide={() => {
              setVisibleBottom(false);
              ReactGA.event({
                category: 'Interaction',
                action: `Close Mobile Menu`,
                label: `Close Mobile Menu`,
              });
            }}
            closeOnEscape
            dismissable
            className="theme-bg-black header-none"
            showCloseIcon={false}>
            <div className="nav-sidebar-content flex flex-column h-full align-items-center justify-content-center">
              <div className="flex align-items-center justify-content-between w-10 mx-auto">
                <Link
                  to="/"
                  onClick={() => setVisibleBottom(false)}
                  className="no-underline">
                  {!!logo || !!logoSecondary ? (
                    <img
                      src={logoSecondary?.url || logo?.url}
                      alt={title || ''}
                      className="block"
                      style={{
                        objectFit: 'cover',
                        maxWidth: '100px',
                        maxHeight: '50px',
                      }}
                    />
                  ) : (
                    <h1 className="p-0 m-0">{title}</h1>
                  )}
                </Link>
                <Button
                  icon="pi pi-times"
                  className="bg-none mobile-icon-nav-button"
                  onClick={() => {
                    setVisibleBottom(false);
                    ReactGA.event({
                      category: 'Interaction',
                      action: `Close Mobile Menu`,
                      label: `Close Mobile Menu`,
                    });
                  }}
                />
              </div>
              <nav className="p-0 my-0 w-10 mx-auto mb-4">
                <ul className="mobile-nav-items flex flex-column w-full p-0 mx-0">
                  {navigation?.navigationItems.map(
                    (navigationItem: NavigationItemType) => (
                      <li
                        key={Math.random()}
                        className="my-2 flex flex-column align-items-center justify-content-center">
                        {navigationItem.link.includes('tel') ||
                        navigationItem.link.includes('http') ? (
                          <a
                            href={navigationItem.link}
                            target={navigationItem.sameTab ? '' : '_blank'}
                            className={`w-12 text-center ${navigationItem.cssClass}`}
                            rel="noreferrer"
                            onClick={() => {
                              setVisibleBottom(false);
                              ReactGA.event({
                                category: 'Link',
                                action: `Visit ${navigationItem.label}`,
                                label: `Visit ${navigationItem.label}`,
                              });
                            }}>
                            {navigationItem.label}
                          </a>
                        ) : (
                          <Link
                            to={navigationItem.link}
                            className={`w-12 text-center ${navigationItem.cssClass}`}
                            onClick={() => {
                              setVisibleBottom(false);
                              ReactGA.event({
                                category: 'Link',
                                action: `Visit ${navigationItem.label}`,
                                label: `Visit ${navigationItem.label}`,
                              });
                            }}>
                            {navigationItem.label}
                          </Link>
                        )}
                      </li>
                    ),
                  )}
                </ul>
              </nav>
              <nav className="w-10 mx-auto mb-4 flex flex-row nav-social-icons justify-content-center">
                {!!instagramLink && (
                  <a
                    href={instagramLink}
                    target="_blank"
                    title="Instagram"
                    onClick={() => {
                      ReactGA.event({
                        category: 'Link',
                        action: `Visit ${instagramLink}`,
                        label: `Visit ${instagramLink}`,
                      });
                    }}
                    className="max-w-max mx-2 text-center"
                    rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faInstagram as IconProp}
                      className="fa-fw"
                    />
                    <span className="sr-only">Instagram</span>
                  </a>
                )}
                {!!spotifyLink && (
                  <a
                    href={spotifyLink}
                    target="_blank"
                    title="Spotify"
                    onClick={() => {
                      ReactGA.event({
                        category: 'Link',
                        action: `Visit ${spotifyLink}`,
                        label: `Visit ${spotifyLink}`,
                      });
                    }}
                    className="max-w-max mx-2 text-center"
                    rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faSpotify as IconProp}
                      className="fa-fw"
                    />
                    <span className="sr-only">Spotify</span>
                  </a>
                )}
                {!!facebookLink && (
                  <a
                    href={facebookLink}
                    target="_blank"
                    title="Facebook"
                    onClick={() => {
                      ReactGA.event({
                        category: 'Link',
                        action: `Visit ${facebookLink}`,
                        label: `Visit ${facebookLink}`,
                      });
                    }}
                    className="max-w-max mx-2 text-center"
                    rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faFacebook as IconProp}
                      className="fa-fw"
                    />
                    <span className="sr-only">Facebook</span>
                  </a>
                )}
                {!!twitterLink && (
                  <a
                    href={twitterLink}
                    target="_blank"
                    title="Twitter"
                    onClick={() => {
                      ReactGA.event({
                        category: 'Link',
                        action: `Visit ${twitterLink}`,
                        label: `Visit ${twitterLink}`,
                      });
                    }}
                    className="max-w-max mx-2 text-center"
                    rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faTwitter as IconProp}
                      className="fa-fw"
                    />
                    <span className="sr-only">Twitter</span>
                  </a>
                )}
                {!!youtubeLink && (
                  <a
                    href={youtubeLink}
                    target="_blank"
                    title="YouTube"
                    onClick={() => {
                      ReactGA.event({
                        category: 'Link',
                        action: `Visit ${youtubeLink}`,
                        label: `Visit ${youtubeLink}`,
                      });
                    }}
                    className="max-w-max mx-2 text-center"
                    rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faYoutube as IconProp}
                      className="fa-fw"
                    />
                    <span className="sr-only">Youtube</span>
                  </a>
                )}
                {!!tikTokLink && (
                  <a
                    href={tikTokLink}
                    target="_blank"
                    title="TikTok"
                    onClick={() => {
                      ReactGA.event({
                        category: 'Link',
                        action: `Visit ${tikTokLink}`,
                        label: `Visit ${tikTokLink}`,
                      });
                    }}
                    className="max-w-max mx-2 text-center"
                    rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faTiktok as IconProp}
                      className="fa-fw"
                    />
                    <span className="sr-only">TikTok</span>
                  </a>
                )}
              </nav>
              <div className="w-10 mx-auto mb-4">
                {!!bookingPhoneOne && (
                  <div className="mt-auto mb-4 px-4">
                    {!!bookingNameOne && (
                      <p className="font-bold text-sm">{bookingNameOne}</p>
                    )}
                    {!!bookingEmailOne && (
                      <p className="flex align-items-center text-sm">
                        <FontAwesomeIcon
                          icon={faEnvelope as IconProp}
                          className="fa-fw mr-2"
                        />
                        <a
                          href={`mailto:${bookingEmailOne}`}
                          target="_blank"
                          className="text-link"
                          rel="noreferrer">
                          {bookingEmailOne}
                        </a>
                      </p>
                    )}
                    {!!bookingPhoneOne && (
                      <p className="flex align-items-center text-sm">
                        <FontAwesomeIcon
                          icon={faPhone as IconProp}
                          className="fa-fw mr-2"
                        />
                        <a
                          href={`tel:${bookingPhoneOne}`}
                          target="_blank"
                          className="text-link"
                          rel="noreferrer">
                          {bookingPhoneOne}
                        </a>
                      </p>
                    )}
                  </div>
                )}
                <Button
                  label={isSpanish ? 'Cerrar' : 'Close'}
                  className="bg-none text-primary mb-4 p-1 w-full"
                  onClick={() => {
                    setVisibleBottom(false);
                    ReactGA.event({
                      category: 'Interaction',
                      action: `Close Mobile Menu`,
                      label: `Close Mobile Menu`,
                    });
                  }}
                />
              </div>
            </div>
          </Sidebar>
          <nav
            className="mobile-nav-wrapper fixed theme-bg-black w-full block theme-box-shadow shadow-direction-up "
            style={{ bottom: 0, zIndex: 1000, left: 0, right: 0 }}>
            <div className="flex align-items-center justify-content-between w-full px-4 py-3">
              <Link
                to="/"
                className="no-underline uppercase"
                onClick={() => {
                  ReactGA.event({
                    category: 'Link',
                    action: `Visit Home`,
                    label: `Visit Home`,
                  });
                }}>
                {!!logo || !!logoSecondary ? (
                  <img
                    src={logoSecondary?.url || logo?.url}
                    alt={title || ''}
                    className="block"
                    style={{
                      objectFit: 'cover',
                      maxWidth: '100px',
                      maxHeight: '40px',
                    }}
                  />
                ) : (
                  <h2 className="p-0 m-0">{title}</h2>
                )}
              </Link>
              <Button
                icon="pi pi-bars"
                className="bg-none mobile-icon-nav-button"
                onClick={() => {
                  setVisibleBottom(true);
                  ReactGA.event({
                    category: 'Interaction',
                    action: `Open Mobile Menu`,
                    label: `Open Mobile Menu`,
                  });
                }}
              />
            </div>
          </nav>
        </>
      ) : siteLibraryJson?.centerNav === true ? (
        <>
          <nav
            className={`nav-desktop w-full px-2 center-nav ${
              isScrolled ? 'py-1 theme-bg-black-faded sticky' : 'py-3 absolute'
            }`}
            style={{ top: isScrolled ? '0' : '0', zIndex: 10000 }}>
            <div className="container flex justify-content-center flex-row align-items-center">
              <ul className="flex flex-row mx-auto py-0 my-0 px-0">
                {navigation?.navigationItems.map(
                  (navigationItem: NavigationItemType) => (
                    <li
                      key={Math.random()}
                      className="my-2 flex flex-row align-items-center">
                      {navigationItem.link.includes('tel') ||
                      navigationItem.link.includes('http') ? (
                        <a
                          href={navigationItem.link}
                          target={navigationItem.sameTab ? '' : '_blank'}
                          onClick={() => {
                            ReactGA.event({
                              category: 'Link',
                              action: `Visit ${navigationItem.link}`,
                              label: `Visit ${navigationItem.link}`,
                            });
                          }}
                          className={`no-underline text-link ${navigationItem.cssClass}`}
                          rel="noreferrer">
                          {navigationItem.label}
                        </a>
                      ) : (
                        <div>
                          {navigationItem?.navLogo ? (
                            <Link
                              to="/"
                              className="no-underline uppercase"
                              onClick={() =>
                                ReactGA.event({
                                  category: 'Link',
                                  action: `Visit ${navigationItem.link}`,
                                  label: `Visit ${navigationItem.link}`,
                                })
                              }>
                              {!!logo || !!logoSecondary ? (
                                <img
                                  src={logoSecondary?.url || logo?.url}
                                  alt={title || ''}
                                  className={`primary-logo ${
                                    isScrolled ? 'scrolled' : ''
                                  }`}
                                />
                              ) : (
                                <p
                                  className={`nav-text-title p-0 m-0 ${
                                    isScrolled ? 'scrolled' : ''
                                  }`}>
                                  {title}
                                </p>
                              )}
                            </Link>
                          ) : (
                            <Link
                              to={navigationItem.link}
                              onClick={() =>
                                ReactGA.event({
                                  category: 'Link',
                                  action: `Visit ${navigationItem.link}`,
                                  label: `Visit ${navigationItem.link}`,
                                })
                              }
                              className={`no-underline text-link ${navigationItem.cssClass}`}>
                              {navigationItem.label}
                            </Link>
                          )}
                        </div>
                      )}
                    </li>
                  ),
                )}
              </ul>
            </div>
          </nav>
          <div className="spacer" />
        </>
      ) : (
        <nav
          className={`nav-desktop w-full theme-bg-black sticky px-2 ${
            isScrolled ? 'py-1' : 'py-3'
          }`}
          style={{ top: isScrolled ? '0' : '-225px', zIndex: 10000 }}>
          <div className="container flex justify-content-space-between flex-row align-items-center">
            <Link
              to="/"
              onClick={() =>
                ReactGA.event({
                  category: 'Link',
                  action: `Visit Home`,
                  label: `Visit Home`,
                })
              }
              className="no-underline uppercase">
              {!!logo || !!logoSecondary ? (
                <img
                  src={logoSecondary?.url || logo?.url}
                  alt={title || ''}
                  className={`primary-logo ${isScrolled ? 'scrolled' : ''}`}
                />
              ) : (
                <h1
                  className={`nav-text-title p-0 m-0 ${
                    isScrolled ? 'scrolled' : ''
                  }`}>
                  {title}
                </h1>
              )}
            </Link>
            <ul className="desktop-nav-items flex flex-row ml-auto py-0 my-0">
              {navigation?.navigationItems.map(
                (navigationItem: NavigationItemType) => (
                  <li
                    key={Math.random()}
                    className="my-2 flex flex-row align-items-center">
                    {navigationItem.link.includes('tel') ||
                    navigationItem.link.includes('http') ? (
                      <a
                        href={navigationItem.link}
                        target={navigationItem.sameTab ? '' : '_blank'}
                        className={`${navigationItem.cssClass}`}
                        rel="noreferrer"
                        onClick={() =>
                          ReactGA.event({
                            category: 'Link',
                            action: `Visit ${navigationItem.link}`,
                            label: `Visit ${navigationItem.link}`,
                          })
                        }>
                        {navigationItem.label}
                      </a>
                    ) : (
                      <Link
                        to={navigationItem.link}
                        className={`${navigationItem.cssClass}`}
                        onClick={() =>
                          ReactGA.event({
                            category: 'Link',
                            action: `Visit ${navigationItem.link}`,
                            label: `Visit ${navigationItem.link}`,
                          })
                        }>
                        {navigationItem.label}
                      </Link>
                    )}
                  </li>
                ),
              )}
            </ul>
          </div>
        </nav>
      )}
    </>
  );
}
